import React, { useCallback } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { noop } from 'ui-components/default-props/noop';

import style from '../dropdown-menu-item/dropdown-menu-item.less';

export const DropdownMenuItemGroup = ({
  children,
  className = '',
  theme = '',
  disabled = false,
  index = 0,
  label,
  onRowHover = noop,
  rowHovered = null,
  dropdownMenuType,
  hasLabelOverFlow = false,
}) => {
  const onClick = useCallback((e) => {
    e.stopPropagation();
  }, []);
  const groupClassName = classnames(style['dropdown-menu-item-group'], className);

  let labelClassName = classnames(style.label, hasLabelOverFlow && style['label-has-overflow']);
  if (theme === 'white') {
    labelClassName = style['label-white'];
  }

  return (
    <div className={groupClassName}>
      <div className={labelClassName} onClick={onClick}>
        {label}
      </div>
      <div>
        {React.Children.map(children, (child, childIndex) => {
          const actualIndex = index + childIndex;

          if (typeof child.type === 'string') {
            return React.cloneElement(child, { index: actualIndex });
          }

          return React.cloneElement(child, {
            disabled: disabled || child.props.disabled,
            hovered: actualIndex === rowHovered,
            index: actualIndex,
            onRowHover,
            dropdownMenuType,
          });
        })}
      </div>
    </div>
  );
};

DropdownMenuItemGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  theme: PropTypes.string,
  disabled: PropTypes.bool,
  index: PropTypes.number,
  label: PropTypes.node.isRequired,
  onRowHover: PropTypes.func,
  rowHovered: PropTypes.number,
  dropdownMenuType: DropdownMenuTypePropType,
  hasLabelOverFlow: PropTypes.bool,
};
